import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Auth0App from './Auth0App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { 
  AUTH0_DOMAIN, 
  AUTH0_CLIENT_ID, 
  AUTH0_AUDIENCE,
  AUTH0_REDIRECT_URI,
  USE_AUTH0,
  DEPLOYMENT_REGION
} from './utils/constants';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (USE_AUTH0) {
  // Handle redirect after Auth0 login to restore intended destination
  const onRedirectCallback = (appState) => {
    // eslint-disable-next-line no-restricted-globals
    window.history.replaceState(
      {},
      document.title,
      // eslint-disable-next-line no-restricted-globals
      appState?.returnTo || window.location.pathname
    );
  };

  // Auth0 authentication
  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={AUTH0_DOMAIN}
        clientId={AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: AUTH0_REDIRECT_URI,
          audience: AUTH0_AUDIENCE
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
        useRefreshTokensFallback={true}
        onRedirectCallback={onRedirectCallback}
      >
        <BrowserRouter>
          <Auth0App />
        </BrowserRouter>
      </Auth0Provider>
    </React.StrictMode>
  );
} else if (DEPLOYMENT_REGION === "USA") {
  // Cognito authentication (USA)
  // Dynamic import to avoid initializing unused auth providers
  import('./CognitoApp').then((module) => {
    const CApp = module.default;
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <CApp />
        </BrowserRouter>
      </React.StrictMode>
    );
  });
} else {
  // Keycloak authentication (China)
  // Dynamic import to avoid initializing unused auth providers
  import('./KeycloakApp').then((module) => {
    const KApp = module.default;
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <KApp />
        </BrowserRouter>
      </React.StrictMode>
    );
  });
}

reportWebVitals();
